const setLocale = (state, locale) => {
  state.locale = locale;
}

export default {
  setLocale,
};